import { TResultImageCoordinatesSchema } from '@/schemas/vehicule-check-result/result-image-coordinates.schema';
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';

type ModerationContextType = {
  activateModeration: boolean;
  setActivateModeration: (value: boolean) => void;
  element: TResultImageCoordinatesSchema | undefined;
  setElement: Dispatch<SetStateAction<TResultImageCoordinatesSchema>>;
  setImgToModerate: Dispatch<SetStateAction<string>>;
  imgToModerate: string;
  dmg: TResultImageCoordinatesSchema;
  setDmg: Dispatch<SetStateAction<TResultImageCoordinatesSchema>>;
  setCurrentItemEdit: Dispatch<
    SetStateAction<{
      id: string;
      url: string;
      name: string;
      coordinatesModerated: TResultImageCoordinatesSchema;
      currentImageIndex?: number;
    }>
  >;
  currentItemEdit: {
    id: string;
    url: string;
    name: string;
    coordinatesModerated: TResultImageCoordinatesSchema;
  };
};

type ModerationProviderType = {
  children: ReactNode;
};

export const ModerationContext = createContext<ModerationContextType | null>(
  null
);

const ModerationProvider = ({ children }: ModerationProviderType) => {
  const [activateModeration, setActivateModerationState] =
    useState<boolean>(false);
  const activateModerationRef = useRef<boolean>(false); // Ref to store the current value
  const [element, setElementState] = useState<
    TResultImageCoordinatesSchema | undefined
  >(undefined);
  const elementRef = useRef<TResultImageCoordinatesSchema | undefined>(
    undefined
  );
  const [dmg, setDmg] = useState<TResultImageCoordinatesSchema>(undefined);
  const [imgToModerate, setImgToModerate] = useState<string>('');
  const [currentItemEdit, setCurrentItemEdit] = useState<{
    id: string;
    url: string;
    name: string;
    coordinatesModerated: TResultImageCoordinatesSchema;
    currentImageIndex?: number;
  }>({
    id: '',
    url: '',
    name: '',
    coordinatesModerated: undefined,
    currentImageIndex: undefined,
  });

  const setElement = (value: TResultImageCoordinatesSchema) => {
    elementRef.current = value; // Update the ref immediately
    setElementState(value); // Trigger a re-render
  };

  const setActivateModeration = (value: boolean) => {
    activateModerationRef.current = value; // Update the ref immediately
    setActivateModerationState(value); // Trigger a re-render
  };

  useEffect(() => {
    console.warn('Updated activateModeration:', activateModeration);
  }, [activateModeration]);

  useEffect(() => {
    console.warn('Updated element:', element);
  }, [element]);

  return (
    <ModerationContext.Provider
      value={{
        activateModeration,
        setActivateModeration,
        element,
        setElement,
        setImgToModerate,
        imgToModerate,
        dmg,
        setDmg,
        currentItemEdit,
        setCurrentItemEdit,
      }}
    >
      {children}
    </ModerationContext.Provider>
  );
};

export default ModerationProvider;
